import { injectable } from 'inversify';
import ApiClient from './api-client';
import { IDownloadService } from './interfaces';

@injectable()
class DownloadService implements IDownloadService {
  private downloadApiClient: ApiClient;

  private appsApiClient: ApiClient;

  public constructor() {
    this.downloadApiClient = new ApiClient(
      process.env.DOWNLOAD_API_BASE_URL ?? ''
    );

    this.appsApiClient = new ApiClient(process.env.APPS_API_BASE_URL ?? '');
  }

  /**
   * Make a request to the download service to get the redirect URL
   * @param tenantId The tenant ID
   * @param packageId The package Id
   * @param appId The App Id
   * @param storeFront the storefront for the app selected
   * @param trackingEnabled Whether tracking is enabled for this App
   * @returns Complete redirect Url to forward the user to
   */
  public async getRedirect(
    tenantId: string,
    packageId: string,
    appId: string,
    storeFront: string,
    trackingId: string
  ): Promise<string | undefined> {
    const body = {
      storeFront: storeFront === 'web' ? 'WebApp' : storeFront,
      sessionId: trackingId,
      trackingType: 'download',
    };
    const response =
      await this.downloadApiClient.postWithResponse<IGetRedirectUrlDataWrapper>(
        `v1/tenants/${tenantId}/packages/${packageId}/platform/AppLibrary/apps/${appId}/download`,
        body
      );

    return response.data;
  }
}

interface IGetRedirectUrlDataWrapper {
  status: string;
  data: string;
}
export default DownloadService;
